module.exports = __webpack_public_path__ + "f6b7fa80605e2ac2f3dbb0ea611d1058.svg";